












































import Vue from "vue";
import { computed, ref } from "@vue/composition-api";
import { state } from "../data/state";
import { SharedState } from "@/common/state";
import { sortBy } from "@/fp";
import { AxisType, TimeAxisType } from "@/gql/types";
import events_handler from "../entities/events";
import { PopulationTypeHelper, POPULATION_TYPE } from "@/common/models";
import { AppAnalytics } from "@/analytics";
export default Vue.extend({
  setup() {
    const { insights_counters, current_subject } = state;
    const get_color = (severity: number) => {
      switch (severity) {
        case 1:
          return "var(--level-l)";
        case 2:
          return "var(--level-m)";
        case 3:
        default:
          return "var(--level-h)";
      }
    };

    const time_frame_str = computed(() =>
      SharedState.selectedTimeFrameDisplayName.value.replace(/\((.+)\)/, "")
    );

    const show_insights = ref(false);
    const toggle_information_risk_overview_section = () => {
      show_insights.value = !show_insights.value;
      if (show_insights.value) {
        AppAnalytics.report({
          component: "Investigation",
          eventName:
            "Investigation_tier#2 summary tab_entity's_click on Information Risks Overview",
        });
      }
    };

    const displayed_insights = computed(() =>
      sortBy(insights_counters.value, "severity", true)
        .filter((d) => SharedState.indexed_insights.value[d.id].infoTypeId)
        .filter((s: any) => {
          const insight = SharedState.indexed_insights.value[s.id];
          const filter_for_label = (label_id: string) => {
            const label = SharedState.getInfoType(label_id);
            return (
              label.code === SharedState.getInfoType(insight.infoTypeId).code &&
              insight.sensitivity >= label.sensitivityLevel
            );
          };
          return (
            s.severity > 0 &&
            insight.riskType ===
              "generic" /*  &&
            (current_subject.value.type === "LABEL"
              ? filter_for_label(current_subject.value.id)
              : true) */
          );
        })
        .map((d) => {
          return { ...d, color: get_color(d.severity) };
        })
    );

    const insight_count_total = computed(() =>
      insights_counters.value.reduce((acc, insight) => {
        acc += insight.count;
        return acc;
      }, 0)
    );

    const isMonthTimeFrame = computed(
      () =>
        SharedState.selectedTimeFrameOption.value.type === TimeAxisType.Month
    );

    const show_events_for_insight = (
      insight_id: string,
      insight_name: string
    ) => {
      const { type, from } = SharedState.selectedTimeFrameOption.value;
      SharedState.ifIsPayingUser(
        () => {
          const entity_type =
            current_subject.value.type == POPULATION_TYPE.EMPLOYEE
              ? AxisType.Employee
              : PopulationTypeHelper.asAxisType(current_subject.value.type);
          const cords = [
            {
              x: {
                type: AxisType.Insight,
                values: [insight_id],
              },
              y: {
                type: entity_type,
                values: [current_subject.value.id],
              },
              z: {
                type,
                values: [from],
              },
            },
          ];
          events_handler.show_modal(current_subject.value, {
            coordinates: cords,
            events_alt_title: `Events that include <b>${insight_name}</b>`,
          });
        },
        { premium_modal_key: "forensics-popup-2024" }
      );
    };

    return {
      show_insights,
      toggle_information_risk_overview_section,
      displayed_insights,
      insight_count_total,
      time_frame_str,
      isMonthTimeFrame,
      show_events_for_insight,
    };
  },
});
